import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ComplianceLocationIddProgressModel } from 'src/app/models/compliance/compliance-location-idd-progress.model';
import { TableColumn } from 'src/app/models/table-column.model';

@Component({
  selector: 'app-compliance-location-qualification-status',
  standalone: false,
  templateUrl: './compliance-location-qualification-status.component.html',
  styleUrl: './compliance-location-qualification-status.component.scss',
})
export class ComplianceLocationQualificationStatusComponent {
  @Input()
  complianceLocationIddProgress!: ComplianceLocationIddProgressModel[];

  complianceLocationQualificationData: any[] = [];

  complianceLocationQualificationColumns: TableColumn[] = [
    {
      caption: this.translateService.instant('COMMON.FIELDS.NAME'),
      dataField: 'name',
      dataType: 'string',
      disableFiltering: true,
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.PROGRESS'),
      dataField: 'progress',
      dataType: 'string',
      disableFiltering: true,
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.PROGRESS') + ' %',
      dataField: 'progressPercentage',
      dataType: 'string',
      name: 'progressPercentage',
      calculateDisplayValue: (data: any): string => {
        return data.progressPercentage + ' %';
      },
      disableFiltering: true,
    },
    {
      caption: '', //this.translateService.instant('COMMON.FIELDS.PROGRESS-BAR'),
      dataField: 'progressPercentage',
      dataType: 'string',
      name: 'progressPercentageBar',
      cellTemplate: 'progressBullet',
      disableFiltering: true,
    },
  ];

  constructor(
    private translateService: TranslateService,
  ) {
    
  }

  ngOnInit() {
    if (this.complianceLocationIddProgress) {
      this.complianceLocationQualificationData = this.complianceLocationIddProgress
      .map((data, index) => {
        const completed = data.completedPersonsCount ?? 0;
        const open = data.openPersonsCount ?? 0;
        const total = completed + open;

        return {
          id: index,
          name: data.locationName,
          progress: `${completed} / ${total}`,
          progressPercentage: total > 0 ? Math.min(Math.round((completed / total) * 100), 100) : 0,
        };
      })
      .sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    }
    }
}
